

	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { ArtistIndex } from '@shared/models';

	@Component({})
	export default class ArtistBrowse extends BaseView {


		public list: ArtistIndex[] = [];

		/** Fires when this component is mounted */
		public async mounted() {
			this.setTitle('Artists - SkateLurker');
			await this.refresh();
		}

		public async refresh() {
			try {
				this.loading = true;
				this.list = await this.$api.artistService.index();
			} catch (err) {
				this.errorMessage = 'An error occurred while getting the results';
				this.errorHandler.handle(err, this.errorMessage);
			} finally {
				this.loading = false;
			}
		}


	}

